import React, { useEffect, useState } from "react";
import { useHookstate } from "@hookstate/core";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import {
    isUserAdmin,
    isUserSupport,
    isUserMaster
} from "../../../../constant";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import {
    Heading,
    WorkSection,
    ActionWrapper
} from "pages/Fleet/Settings/SettingsStyled";
import { useDispatch, useSelector } from "react-redux";
import "react-quill/dist/quill.snow.css";
import { Button } from "@mui/material";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { FLEET_SERVICES } from "redux/reduxToolkitServices/_commonServices/fleetServices";
import EyeSlashIcon from "assets/svgIcons/PeopleSubSideNav/EyeSlashIcon";
import EyeIcon from "assets/svgIcons/PeopleSubSideNav/EyeIcon";

export const SSIDListAccordion = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { getUserRole } = useSelector((state) => state?.commonReducers) || [];
    const { getSsidData } = useSelector((state) => state?.fleetReducers) || [];

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const [ssid1, setSsid1] = useState("");
    const [password1, setPasssword1] = useState("");
    const [ssid2, setSsid2] = useState("");
    const [password2, setPasssword2] = useState("");
    const [ssid3, setSsid3] = useState("");
    const [password3, setPasssword3] = useState("");
    const [ssid4, setSsid4] = useState("");
    const [password4, setPasssword4] = useState("");
    const [ssid5, setSsid5] = useState("");
    const [password5, setPasssword5] = useState("");
    const [showPasswords, setShowPasswords] = useState(false);
    const [hasDataChanged, setHasDataChanged] = useState(false);

    const siteIdValue = siteId.get();

    useEffect(() => {
        dispatch(FLEET_SERVICES.getSsidDataService(siteIdValue));
    }, []);

    useEffect(() => {
        if (getSsidData && Object.keys(getSsidData).length > 0) {
            setSsid1(getSsidData?.Ssid1 || "");
            setPasssword1(getSsidData?.Password1 || "");
            setSsid2(getSsidData?.Ssid2 || "");
            setPasssword2(getSsidData?.Password2 || "");
            setSsid3(getSsidData?.Ssid3 || "");
            setPasssword3(getSsidData?.Password3 || "");
            setSsid4(getSsidData?.Ssid4 || "");
            setPasssword4(getSsidData?.Password4 || "");
            setSsid5(getSsidData?.Ssid5 || "");
            setPasssword5(getSsidData?.Password5 || "");
        }
    }, [getSsidData]);

    const saveSsiData = () => {
        const payload = {
            ssid1, password1,
            ssid2, password2,
            ssid3, password3,
            ssid4, password4,
            ssid5, password5,
            siteId: siteIdValue
        };
        dispatch(FLEET_SERVICES.setSSIDDataService(siteIdValue, payload));
    };

    // Determine disabled states
    const isDisabled2 = !(ssid1 && password1);

    const isDisabled3 = !(ssid2 && password2);
    const isDisabled4 = !(ssid3 && password3);
    const isDisabled5 = !(ssid4 && password4);

    const togglePasswordVisibility = () => {
        setShowPasswords(prev => !prev);
    }

    const handleInputChange = (setter, originalValue) => (e) => {
        const value = e.target.value;
        setter(value);

        setHasDataChanged(
            getSsidData?.ssid1 != undefined &&
            value !== originalValue ||
            ssid1 !== (getSsidData?.ssid1 || "") ||
            password1 !== (getSsidData?.password1 || "") ||
            ssid2 !== (getSsidData?.ssid2 || "") ||
            password2 !== (getSsidData?.password2 || "") ||
            ssid3 !== (getSsidData?.ssid3 || "") ||
            password3 !== (getSsidData?.password3 || "") ||
            ssid4 !== (getSsidData?.ssid4 || "") ||
            password4 !== (getSsidData?.password4 || "") ||
            ssid5 !== (getSsidData?.ssid5 || "") ||
            password5 !== (getSsidData?.password5 || "")
        );
    }

    const resetForm = () => {
        setSsid1(getSsidData?.ssid1 || "");
        setPasssword1(getSsidData?.password1 || "");

        setSsid2(getSsidData?.ssid2 || "");
        setPasssword2(getSsidData?.password2 || "");

        setSsid3(getSsidData?.ssid3 || "");
        setPasssword3(getSsidData?.password3 || "");

        setSsid4(getSsidData?.ssid4 || "");
        setPasssword4(getSsidData?.password4 || "");

        setSsid5(getSsidData?.ssid5 || "");
        setPasssword5(getSsidData?.password5 || "");

        setShowPasswords(false);
    }

    const isSaveDisabled =
        !ssid1 || !password1 ||
        (ssid2 && !password2) ||
        (ssid3 && !password3) ||
        (ssid4 && !password4) ||
        (ssid5 && !password5);

    const containerStyle = {
        width: 600,
        padding: 15,
        border: "2px solid #ccc",
        borderRadius: 8,
        backgroundColor: "#f9f9f9"
    };

    const rowStyle = { display: "flex", gap: 10, marginBottom: 10 };
    const headerStyle = { display: "flex", gap: 10, marginBottom: 10, fontWeight: "bold" };

    return (
        <>
            {(isUserAdmin(getUserRole?.Role) || isUserMaster(getUserRole?.Role) || isUserSupport(getUserRole?.Role)) &&
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Heading>
                            <h3>{t("Wifi_SSID_List")}</h3>
                            {hasDataChanged &&
                                <span style={{ textAlign: 'center', backgroundColor: '#ffe8e8', border: '2px solid white' }}>
                                    <span style={{ fontSize: '10pt', padding: '5px', color: 'red' }}>Changed</span>
                                </span>
                            }
                        </Heading>
                    </AccordionSummary>
                    <AccordionDetails>
                        <WorkSection>
                            <div style={containerStyle}>
                                <div style={headerStyle}>
                                    <div style={{ width: "50%" }}>SSID</div>
                                    <div style={{ width: "50%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <span>
                                            Passphrase <span style={{ color: "red" }}>*</span>
                                        </span>
                                        <div onClick={togglePasswordVisibility} style={{ cursor: "pointer" }}>
                                            {showPasswords ?
                                                <EyeIcon style={{ verticalAlign: 'middle' }} /> :
                                                <EyeSlashIcon style={{ verticalAlign: 'middle' }} />
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div style={rowStyle}>
                                    <input type="text" autoComplete="off" value={ssid1} onChange={handleInputChange(setSsid1, getSsidData?.ssid1 || "")} />
                                    <input
                                        type={showPasswords ? "text" : "password"}
                                        value={password1}
                                        autoComplete="new-password"
                                        onChange={handleInputChange(setPasssword1, getSsidData?.password1 || "")}
                                    />
                                </div>
                                {ssid1 && !password1 && (
                                    <div style={{ color: "red", fontSize: 10, fontWeight: "bold", textAlign: "right", marginTop: -15 }}>
                                        passphrase is required
                                    </div>
                                )}

                                <div style={rowStyle}>
                                    <input type="text" autoComplete="off" value={ssid2} onChange={handleInputChange(setSsid2, getSsidData?.ssid2 || "")} disabled={isDisabled2} />
                                    <input
                                        type={showPasswords ? "text" : "password"}
                                        value={password2}
                                        autoComplete="new-password"
                                        onChange={handleInputChange(setPasssword2, getSsidData?.password2 || "")}
                                        disabled={isDisabled2}
                                    />
                                </div>
                                {ssid2 && !password2 && (
                                    <div style={{ color: "red", fontSize: 10, fontWeight: "bold", textAlign: "right", marginTop: -15 }}>
                                        passphrase is required
                                    </div>
                                )}

                                <div style={rowStyle}>
                                    <input type="text" autoComplete="off" value={ssid3} onChange={handleInputChange(setSsid3, getSsidData?.ssid3 || "")} disabled={isDisabled3} />
                                    <input
                                        type={showPasswords ? "text" : "password"}
                                        value={password3}
                                        autoComplete="new-password"
                                        onChange={handleInputChange(setPasssword3, getSsidData?.password3 || "")}
                                        disabled={isDisabled3}
                                    />
                                </div>
                                {ssid3 && !password3 && (
                                    <div style={{ color: "red", fontSize: 10, fontWeight: "bold", textAlign: "right", marginTop: -15 }}>
                                        passphrase is required
                                    </div>
                                )}

                                <div style={rowStyle}>
                                    <input type="text" autoComplete="off" value={ssid4} onChange={handleInputChange(setSsid4, getSsidData?.ssid4 || "")} disabled={isDisabled4} />
                                    <input
                                        type={showPasswords ? "text" : "password"}
                                        value={password4}
                                        autoComplete="new-password"
                                        onChange={handleInputChange(setPasssword4, getSsidData?.password4 || "")}
                                        disabled={isDisabled4}
                                    />
                                </div>
                                {ssid4 && !password4 && (
                                    <div style={{ color: "red", fontSize: 10, fontWeight: "bold", textAlign: "right", marginTop: -15 }}>
                                        passphrase is required
                                    </div>
                                )}

                                <div style={rowStyle}>
                                    <input type="text" autoComplete="off" value={ssid5} onChange={handleInputChange(setSsid5, getSsidData?.ssid5 || "")} disabled={isDisabled5} />
                                    <input
                                        type={showPasswords ? "text" : "password"}
                                        value={password5}
                                        autoComplete="new-password"
                                        onChange={handleInputChange(setPasssword5, getSsidData?.password5 || "")}
                                        disabled={isDisabled5}
                                    />
                                </div>
                                {ssid5 && !password5 && (
                                    <div style={{ color: "red", fontSize: 10, fontWeight: "bold", textAlign: "right", marginTop: -15 }}>
                                        passphrase is required
                                    </div>
                                )}

                                <ActionWrapper>
                                    <Button
                                        onClick={saveSsiData}
                                        className={isSaveDisabled || !(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role)) ? "disabled" : "active"}
                                        disabled={isSaveDisabled || !(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role))}>
                                        {t("Save")}
                                    </Button>
                                    <Button onClick={resetForm} disabled={!(isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role) || isUserMaster(getUserRole?.Role))}>
                                        {t("Cancel")}
                                    </Button>
                                </ActionWrapper>
                            </div>
                        </WorkSection>
                    </AccordionDetails>
                </Accordion>
            }
        </>
    );
};